export const dummyPermissions = [
	{
		"name": "Users",
		"description": "Users Module that includes user management, permissions, and roles",
		"code": "USER_MODULE",
		"permission_levels": ["VIEW", "UPDATE", "CREATE", "DELETE"],
		"child_permissions": [
			{
				"name": "Basic",
				"description": "Allows to view and modify basic aspects of users",
				"code": "USER_BASIC",
				"permission_levels": ["VIEW", "UPDATE"],
				"child_permissions": [
					{
						"name": "User Info",
						"description": "Allows to view and modify user basic information",
						"code": "USER_BASIC_INFO",
						"permission_levels": ["VIEW", "UPDATE"],
						"child_permissions": []
					},
					{
						"name": "User Role",
						"description": "Allows to view and modify user roles",
						"code": "USER_BASIC_ROLE",
						"permission_levels": ["VIEW", "UPDATE"],
						"child_permissions": []
					},
					{
						"name": "User Permissions",
						"description": "Allows to view and modify user permissions",
						"code": "USER_BASIC_PERMISSIONS",
						"permission_levels": ["VIEW", "UPDATE"],
						"child_permissions": []
					},
					{
						"name": "User Status",
						"description": "Allows to view and modify user status",
						"code": "USER_BASIC_STATUS",
						"permission_levels": ["VIEW", "UPDATE"],
						"child_permissions": []
					},
					{
						"name": "User Contact",
						"description": "Allows to view and modify user contact information",
						"code": "USER_BASIC_CONTACT",
						"permission_levels": ["VIEW", "UPDATE"],
						"child_permissions": []
					}
				]
			},
			{
				"name": "Advanced",
				"description": "Allows to manage advanced user settings and configurations",
				"code": "USER_ADVANCED",
				"permission_levels": ["VIEW", "UPDATE"],
				"child_permissions": [
					{
						"name": "User Groups",
						"description": "Allows to manage user groups and memberships",
						"code": "USER_ADVANCED_GROUPS",
						"permission_levels": ["VIEW", "UPDATE"],
						"child_permissions": []
					},
					{
						"name": "User Settings",
						"description": "Allows to manage advanced user settings",
						"code": "USER_ADVANCED_SETTINGS",
						"permission_levels": ["VIEW", "UPDATE"],
						"child_permissions": []
					},
					{
						"name": "User Actions",
						"description": "Allows to perform advanced user actions",
						"code": "USER_ADVANCED_ACTIONS",
						"permission_levels": ["VIEW", "UPDATE"],
						"child_permissions": []
					},
					{
						"name": "User Audit",
						"description": "Allows to view and manage user audit logs",
						"code": "USER_ADVANCED_AUDIT",
						"permission_levels": ["VIEW", "UPDATE"],
						"child_permissions": []
					}
				]
			}
		]
	},
	{
		"name": "Agents",
		"description": "Agents Module that includes Vaults, Actions, Agents and Teas",
		"code": "AGENTS_MODULE",
		"permission_levels": ["VIEW", "UPDATE", "CREATE", "DELETE"],
		"child_permissions": [
			{
				"name": "Playground",
				"description": "Allows to use the playground to test agents",
				"code": "PLAYGROUND_FUNCTIONALITY",
				"permission_levels": ["VIEW", "UPDATE"],
				"child_permissions": [
					{
						"name": "Basic",
						"description": "Allows to view and modify basic aspects of the agent",
						"code": "PLAYGROUND_BASIC",
						"permission_levels": ["VIEW", "UPDATE"],
						"child_permissions": [
							{
								"name": "Instructions" ,
								"description": "Allows to give instructions to an agent",
								"code": "PLAYGROUND_BASIC_INSTRUCTIONS",
								"permission_levels": ["VIEW", "UPDATE"],
								"child_permissions": []
							}
						]
					}
				]
			},
			{
				"name": "Vaults",
				"description": "Allows to use the playground to test agents",
				"code": "VAULTS_FUNCTIONALITY",
				"permission_levels": ["VIEW", "UPDATE"],
				"child_permissions": [
				]
			}
		]
	},
	{
		"name": "Contacts",
		"description": "Agents Module that includes Vaults, Actions, Agents and Teas",
		"code": "CONTACTS_MODULE",
		"permission_levels": ["VIEW", "UPDATE", "CREATE", "DELETE"],
		"child_permissions": [
			{
				"name": "Basic",
				"description": "Allows to use the playground to test agents",
				"code": "CONTACTS_FUNCTIONALITY",
				"permission_levels": ["VIEW", "UPDATE"],
				"child_permissions": [
				]
			}
		]
	}
]

export const PermissionsScopes = [
	{name: 'None', value: 'none'},
	{name: 'My own', value: 'own'},
	{name: 'My groups', value: 'groups'},
	{name: 'Rooftop', value: 'rooftop'},
	{name: 'Company', value: 'company'},
]

export const PermissionsScopesIndex = {
	'none': 0,
	'own': 1,
	'groups': 2,
	'rooftop': 3,
	'company': 4,
}